module.exports = ["さくら","ゆい","あかり","めい","はな","さな","りお","ほのか","りこ","みお","さき","みゆ","りん","あい","さら","ひな","いろは","ひかり","はるか","ももか","ゆうな","しおり","ななみ","ゆうか","みさき","あいり","みつき","ひなの","れい","けいこ","さちこ","ようこ","くみこ","えつこ","みゆき","ゆきこ","みさこ","なおみ","おりえ","みらい","あゆみ","あかね","まゆ","ちひろ","みほ","ふゆの","すみれ","あやめ","さくらこ","ふさこ"]


//////////////////
// WEBPACK FOOTER
// ./src/data/collections/names-female.json
// module id = 100
// module chunks = 0